/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";

const Loading: React.FC<{ text: string }> = ({text}) => {
    return (
        <>
            <div className='loader'></div>
            <h2 className='titleText baseText'>{text}</h2>
        </>
    );
};

export default Loading;